export const priceFormatter = new Intl.NumberFormat(undefined, {
  style: 'currency',
  currency: 'EUR'
})

export const dateFormatter = new Intl.DateTimeFormat(undefined, {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
  // We show all datetimes in UTC
  timeZone: 'UTC'
})
